// extracted by mini-css-extract-plugin
export default {"link":"InternalLink_link__sCH4a"};